import { Navigate } from "react-router-dom";
import { usePageTitle } from "../hooks/usePageTitle";

// Not live yet. Until this page has real content, /coming-soon redirects to the homepage
// (client-side, replacing the history entry). Set READY to true in Stage 2 when the heading
// and roadmap content below are written. The real Now / Next / Later content goes in the
// roadmap container.
const READY = false;
const HEADING = "";

export default function ComingSoon() {
  usePageTitle("Coming Soon");
  if (!READY) return <Navigate to="/" replace />;
  return (
    <section style={{ maxWidth: 820, margin: "0 auto", padding: "3.5rem 20px 4rem", textAlign: "center" }}>
      <h1 style={{ fontFamily: "var(--font-voice)", fontSize: "clamp(26px, 4vw, 34px)", color: "var(--navy)", margin: "0 0 32px" }}>
        {HEADING}
      </h1>
      <div id="roadmap" style={{ minHeight: 240 }} />
    </section>
  );
}
